import { render, staticRenderFns } from "./chatAI.vue?vue&type=template&id=a2cf67f4&"
import script from "./chatAI.vue?vue&type=script&lang=js&"
export * from "./chatAI.vue?vue&type=script&lang=js&"
import style0 from "./chatAI.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports